import React from 'react'
import { Comment, Avatar, Form, Button, List, Input, Tooltip } from 'antd'
import moment from 'moment'

import { CommentListWrapper } from './Comments.style'
import { connect } from 'react-redux'
import scumboardAction from '../../../redux/scrumBoard/actions'
import scrumBoardActions from '../../../redux/scrumBoard/actions'

const TextArea = Input.TextArea

const CommentList = ({ comments }) => (
    <CommentListWrapper>
        <List
            dataSource={comments}
            // header={`${comments.length} ${comments.length > 1 ? 'replies' : 'reply'}`}
            itemLayout="horizontal"
            renderItem={props => <Comment {...props} />}
        />
    </CommentListWrapper>
)

const Editor = ({ onChange, onSubmit, submitting, value }) => (
    <div>
        <Form.Item>
            <TextArea rows={4} onChange={onChange} value={value} />
        </Form.Item>
        <Form.Item>
            <Button
                htmlType="submit"
                loading={submitting}
                onClick={onSubmit}
                type="primary"
            >
                Bình luận
            </Button>
        </Form.Item>
    </div>
)
const defaultAvatar = require('../../../resource/image/defaultAvatar.png')
class Comments extends React.Component {
    componentDidMount() {
        const { rid, getListCommentReport } = this.props
        console.log('this.props.rid', rid)
        getListCommentReport(rid)
    }
    state = {
        comments: [
            // {
            //     actions: [<span>Reply to</span>],
            //     author: 'Han Solo',
            //     avatar:
            //         'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
            //     content: (
            //         <p>
            //             We supply a series of design principles, practical
            //             patterns and high quality design resources (Sketch and
            //             Axure), to help people create their product prototypes
            //             beautifully and efficiently.
            //         </p>
            //     ),
            //     datetime: (
            //         <Tooltip
            //             title={moment()
            //                 .subtract(1, 'days')
            //                 .format('YYYY-MM-DD HH:mm:ss')}
            //         >
            //             <span>
            //                 {moment()
            //                     .subtract(1, 'hours')
            //                     .fromNow()}
            //             </span>
            //         </Tooltip>
            //     ),
            // },
        ],
        submitting: false,
        value: '',
    }
    getTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return (tm / 60) >> 0
        }
        if (tm < 86400) {
            return (tm / 3600) >> 0
        }
        if (tm > 86400) {
            return (tm / 86400) >> 0
        }
    }
    getUnitTime = time => {
        const tm = moment().unix() - time
        if (tm < 3600) {
            return 'minutes'
        }
        if (tm < 86400) {
            return 'hours'
        }
        if (tm > 86400) {
            return 'days'
        }
    }
    findCommentOrg = id => {
        const { organizations } = this.props
        const ORG = organizations.find(org => {
            return org.oid === id
        })
        return ORG
    }
    getUser = comment => {
        const { ListUserComment } = this.props
        const user = ListUserComment.find(userCmt => {
            return userCmt.uid === comment.owner_id
        })

        return user
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            const listComment = []
            this.props.ListCommentReport.map(comment => {
                if (comment.report_id === this.props.rid) {
                    const user_avatar =
                        this.getUser(comment) &&
                        this.getUser(comment).avatar !== ''
                            ? this.getUser(comment).avatar
                            : defaultAvatar
                    const orgname = this.findCommentOrg(comment.organ_create)
                        ? ' (' +
                          this.findCommentOrg(comment.organ_create).name +
                          ')'
                        : ''
                    const user_info = this.getUser(comment)
                        ? this.getUser(comment)
                        : {}
                    const dataState = {
                        actions: [],
                        author: user_info.display_name + orgname,

                        avatar: user_avatar,
                        content: <p>{comment.content}</p>,
                        datetime: (
                            <span style={{ fontSize: 13 }}>
                                {moment()
                                    .subtract(
                                        this.getTime(comment.created_time),
                                        this.getUnitTime(comment.created_time)
                                    )
                                    .fromNow()}
                            </span>
                        ),
                    }
                    listComment.push(dataState)
                }
            })
            this.setState({ comments: listComment })
        }
    }

    handleSubmit = () => {
        if (this.state.value.trim() === '') {
            return
        } else {
            const { userInfo, PostComment, rid } = this.props

            const orgname = this.findCommentOrg(userInfo.organ_id)
                ? ' (' + this.findCommentOrg(userInfo.organ_id).name + ')'
                : ''
            this.setState({
                submitting: true,
            })

            setTimeout(() => {
                PostComment({ content: this.state.value, report_id: rid })
                this.setState({
                    submitting: false,
                    value: '',
                    comments: [
                        {
                            actions: [],
                            author: userInfo.display_name + orgname,
                            avatar:
                                userInfo.avatar === ''
                                    ? defaultAvatar
                                    : userInfo.avatar,
                            content: <p>{this.state.value}</p>,
                            datetime: moment().fromNow(),
                        },
                        ...this.state.comments,
                    ],
                })
            }, 200)
        }
    }

    handleChange = e => {
        this.setState({
            value: e.target.value,
        })
    }

    render() {
        const { comments, submitting, value } = this.state
        console.log('comments ', moment().unix())
        console.log('comments data ', this.props.ListCommentReport)
        const { userInfo } = this.props

        return (
            <div>
                {comments.length > 0 && <CommentList comments={comments} />}
                <Comment
                    avatar={
                        <Avatar
                            src={
                                userInfo.avatar === ''
                                    ? defaultAvatar
                                    : userInfo.avatar
                            }
                            alt={userInfo.display_name}
                        />
                    }
                    content={
                        <Editor
                            onChange={this.handleChange}
                            onSubmit={this.handleSubmit}
                            submitting={submitting}
                            value={value}
                        />
                    }
                />
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        ListCommentReport: state.scrumBoard.ListCommentReport,
        organizations: state.organization.organizations,
        ListUserComment: state.scrumBoard.ListUserComment,
        userInfo: state.auth.userInfo,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        commentReport: body => {
            dispatch(scumboardAction.commentReport(body))
        },
        getListCommentReport: rid => {
            dispatch(scumboardAction.getListCommentReport(rid))
        },
        PostComment: body => {
            dispatch(scrumBoardActions.commentReport(body))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Comments)
